<template>
	<div>
		<div class="go-back">
			<span @click="goBack"> {{ $t('Go Back') }}</span>
		</div>
		<div class="wp-title" v-if="category === 'billing'">{{ $t('Billing history') }}</div>
		<div class="wp-title" v-if="category === 'charges'">{{ $t('Charges history') }}</div>
		<div class="table-box" v-if="device === 'pc'">
			<el-table :data="tableData" stripe>
				<el-table-column prop="date" :label="$t('Due Date')"> </el-table-column>
				<el-table-column prop="pay_status" label=""> </el-table-column>
				<el-table-column prop="description" :label="$t('Description')"> </el-table-column>
				<el-table-column prop="type" label=""> </el-table-column>
				<el-table-column prop="amount" :label="$t('Total')"> </el-table-column>
			</el-table>
			<el-pagination
				class="pageing"
				@size-change="loadData"
				@current-change="loadData"
				:current-page.sync="pageIndex"
				:page-sizes="[5, 10, 15, 20]"
				:page-size.sync="pageSize"
				:total="pageTotal"
				layout="total, sizes, prev, pager, next, jumper">
			</el-pagination>
		</div>
		<pull-refresh v-else-if="device === 'mobile'" :enable="enableRefresh" @load="refresh" style="margin-top: 50px" :height="'600px'">
			<div class="mobile-box infinite-list">
				<div class="infinite-list-item" v-for="(item, index) in tableData" :key="index">
					<div>
						<div class="data-amount">{{ item.amount }}</div>
						<div class="data-type">{{ item.type }}</div>
						<div class="data-date">{{ item.date }}</div>
					</div>
					<div style="text-align: right">
						<div>{{ item.pay_status }}</div>
						<div>{{ item.description }}</div>
					</div>
				</div>
			</div>
		</pull-refresh>
	</div>
</template>

<script>
	import { getBillingHistoryList, getChargesList } from '../api';
	import { loadingData } from '../utils';

	import pullRefresh from '../components/PullRefresh.vue';

	export default {
		components: {
			pullRefresh,
		},
		name: 'History',
		data() {
			return {
				category: '',
				tableData: [],
				pageIndex: 1,
				pageSize: 5,
				pageTotal: 0,
				enableRefresh: true,
			};
		},
		mounted() {
			this.category = this.$route.params.category;
			this.loadData();
		},
		computed: {
			device() {
				return window.innerWidth > 768 ? 'pc' : 'mobile';
			},
		},
		methods: {
			goBack() {
				history.back();
			},
			loadData() {
				loadingData(async () => {
					let result = await this.getData(this.pageIndex, this.pageSize);
					this.tableData = result.data_info;
					this.pageTotal = result.total;
				});
			},
			async getData(pageIndex, pageSize) {
				let result = null;
				if (this.category === 'billing') result = await getBillingHistoryList(pageIndex, pageSize);
				else if (this.category === 'charges') result = await getChargesList(pageIndex, pageSize);
				else {
					return alert('参数错误');
				}
				return result;
			},
			refresh(callBack) {
				this.pageIndex += 1;
				this.getData(this.pageIndex, this.pageSize).then((result) => {
					this.tableData = this.tableData.concat(result.data_info);
					this.pageTotal = result.total;
					if (result.data_info.length === 0) this.enableRefresh = false;
					callBack(result.data_info.length > 0);
				});
			},
		},
	};
</script>

<style lang="less" scoped>
	.table-box {
		margin-top: 55px;
	}

	.pageing {
		margin: 30px auto;
		text-align: center;
	}

	.mobile-box {
		display: flex;
		flex-direction: column;
		// margin-top: 26px;
		font-style: normal;
		font-weight: 600;
		font-size: 1.14rem;
		// height: 600px;
		overflow-y: auto;
		-webkit-overflow-scrolling: touch;

		> div {
			margin: 0 auto 10px;
			border: 1px solid rgba(0, 0, 0, 0.1);
			width: 90%;
			box-sizing: border-box;
			padding: 10px;
			display: flex;
			flex-direction: row;
			justify-content: space-between;

			> div {
				> div {
					height: 20px;
				}
				> div + div {
					margin-top: 15px;
				}
			}
		}

		.data-amount {
			font-family: 'Sofia Pro';
			color: rgba(11, 29, 51, 0.6);
		}

		.data-type {
			font-family: 'Sofia Pro';
			color: #000000;
		}

		.data-date {
			font-family: 'Sofia Pro';
			font-weight: 400;
			color: rgba(11, 29, 51, 0.6);
		}
	}
</style>

<style lang="less">
</style>


// WEBPACK FOOTER //
// src/views/History.vue